import type { LanguageRegistry } from "../registry";
import { DEFAULT_STAGES, plaintextStage } from "./stages";
import type { Detection, DetectionInput, DetectionStage } from "./types";

/** Runs stages in order; the first that returns a detection wins. */
export function detectLanguage(
  input: DetectionInput,
  registry: LanguageRegistry,
  stages: readonly DetectionStage[] = DEFAULT_STAGES,
): Detection {
  for (const stage of stages) {
    const detection = stage(input, registry);
    if (detection) return detection;
  }
  return plaintextStage(input, registry) as Detection;
}
